// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Platform_config resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient, RequestOptions } from '../http.js';

export class Platform_configClient {
  constructor(private readonly http: HttpClient) {}

  /** Resolved platform tunables for the authenticated tenant (customer override → platform-global override → code default), plus the catalogue metadata for the customer-adjustable knobs. Operational/display knobs only (thresholds, windows, intervals, precision) — pricing + tier limits come from /v1/pricing (Stripe). */
  async getPlatformConfig(): Promise<{ values: Record<string, unknown>; tunables: Record<string, unknown> }> {
    return this.http.get<{ values: Record<string, unknown>; tunables: Record<string, unknown> }>('/v1/platform-config');
  }

  /** Set (or clear) a tenant-scoped override for a customer-adjustable tunable. Only `customer`/`both`-scoped keys are writable here, and the value must fall within the tunable's declared bounds. Pass value:null to clear the override and fall back to the platform default. */
  async setPlatformConfig(request: { key: string; value?: unknown | null }, requestOptions?: RequestOptions): Promise<{ key: string; value: unknown | null }> {
    return this.http.request<{ key: string; value: unknown | null }>('PUT', '/v1/platform-config', request, undefined, requestOptions);
  }
}
